import {
    Component,
    h,
    Host,
    Prop,
} from '@stencil/core';
import dayjs from 'dayjs';

import store from '../../store/store';
import setDayJsLocale from '../../utils/localization/dayJsLocales';

@Component({
    tag: 'portal-date',
    styleUrl: 'portal-date.scss',
    shadow: true,
})
export class PortalDate {
    /**
   * What format should the content have, `absolute` or `relative`.
   *
   */
    @Prop() relative = false;

    /**
   * The `timezone` for which the current date is displayed.
   *
   */
    @Prop() timezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Etc/UTC';

    /**
   * The input `Date` that needs to be formatted. In epoch format it needs to be a number in seconds
   *
   */
    @Prop() date: Date | string | number;

    /**
   * The time format, defaults to `L LTS`.
   *
   */
    @Prop() format = 'L LTS';

    render() {
        setDayJsLocale(store.get('locale'));

        return (
            <Host>
                <portal-tooltip disabled={!this.relative} text={this._time()}>
                    <div data-test="portal-date">{this.relative ? this._time(true) : this._time()}</div>
                </portal-tooltip>
            </Host>
        );
    }

    private _time(relative = false) {
        if (!this.date) {
            return '';
        }
        let parsedDate = this.date;
        if (typeof this.date === 'number') {
            parsedDate = new Date(this.date * 1000);
        }

        return relative ?
            dayjs(parsedDate).fromNow() :
            dayjs(parsedDate)
                .tz(this.timezone)
                .format(this.format);
    }
}
